module.exports = __webpack_public_path__ + "static/media/sort-up.9ca1b7b0.svg";